import { BROKER_CONNECT_ACTION_TYPES } from '@constants/actionTypes/brokerConnectTypes';


export const INITIAL_STATE = {
    available: false,
    brokerAvailabilities: [
        { day: 'Monday', fromTime: '08:00', toTime: '17:00' },
        { day: 'Tuesday', fromTime: '08:00', toTime: '17:00' },
        { day: 'Wednesday', fromTime: '08:00', toTime: '17:00' },
        { day: 'Thursday', fromTime: '08:00', toTime: '17:00' },
        { day: 'Friday', fromTime: '08:00', toTime: '17:00' },
        { day: 'Saturday', fromTime: 'closed', toTime: 'closed' },
        { day: 'Sunday', fromTime: 'closed', toTime: 'closed' } 
    ],
    encryptedBrokerId: null,
    phoneNumber: '',
    status: 'INACTIVE'
};

export default function(state = INITIAL_STATE, action = {}) {
    switch(action.type) {
        case BROKER_CONNECT_ACTION_TYPES.SET_BROKERCONNECT_DATA:
        case BROKER_CONNECT_ACTION_TYPES.SET_BROKERCONNECT_DATA_WITHOUT_SAVE: 
            return {
                ...state,
                ...action.payload
            };
    }    
    return state;
}